import {
  CHAMBER_ROW_CONTEXT_SELECTED,
  CONTEXT_ELEMENT_DESELECT
} from "../lib/types";

export const selectRow = row => dispatch => {
  dispatch({
    type: CHAMBER_ROW_CONTEXT_SELECTED,
    payload: row
  });
};

export const deselectRow = () => dispatch => {
  dispatch({
    type: CONTEXT_ELEMENT_DESELECT
  });
};



// WEBPACK FOOTER //
// ./src/actions/chamber-row-actions.js